export default __webpack_public_path__ + "static/media/Excellent Brawlbracer Ale.737be200.jpg";